import { useMutation } from '@tanstack/react-query';
import { deleteDraft } from '../../services';

export function useDeleteDraft() {
  return useMutation(deleteDraft, { onSuccess: (data) => data });
}
